// Public request-bin / echo services for trying out an endpoint without a real
// backend. Shared by onboarding and the endpoint settings tab.
export const TEST_URLS: { label: string; url: string }[] = [
  { label: 'httpbin.org/post', url: 'https://httpbin.org/post' },
  { label: 'webhook.site', url: 'https://webhook.site' },
  { label: 'requestbin.com', url: 'https://requestbin.com' },
]
